import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { process, State } from '@progress/kendo-data-query';
import { TranslateService } from '@ngx-translate/core';
import { StatisticsService } from '../statistics.service';
import {
  DataBindingDirective,
  ExcelExportEvent,
  CellClickEvent,
  GridDataResult,
  MultipleSortSettings,
  DataStateChangeEvent
} from '@progress/kendo-angular-grid';
import { DeviceUser } from '../../../../shared/models/DeviceUser';
import { DeviceUserType } from '../../../../shared/models/DeviceUserType';
import { ExcelExportComponent, ExcelExportData, Workbook } from '@progress/kendo-angular-excel-export';
import { saveAs } from '@progress/kendo-file-saver';
import { ChartComponent } from '@progress/kendo-angular-charts';
import { drawDOM, exportPDF, Group } from '@progress/kendo-drawing';
import moment from 'moment';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from 'src/app/core/constants';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'app-statistics-new',
    templateUrl: './statistics-new.component.html',
    styleUrls: ['./statistics-new.component.css'],
    standalone: false
})
export class StatisticsNewComponent implements OnInit {

  constructor(private _translate: TranslateService, private _statisticsKendoService: StatisticsService, private intlService: IntlService, public router: Router, public jwtHelper: JwtHelperService) {
    this.amountContent = this.amountContent.bind(this);
    this.quantityContent = this.quantityContent.bind(this);
    this.quantityAmountContent = this.quantityAmountContent.bind(this);
  }

  @Input() event: any;
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

  @ViewChild('salesCategoryChart') private salesCategoryChart: ChartComponent;
  @ViewChild('salesDeviceChart') private salesDeviceChart: ChartComponent;
  @ViewChild('qtyDeviceChart') private qtyDeviceChart: ChartComponent;
  @ViewChild('salesTablesChart') private salesTablesChart: ChartComponent;
  @ViewChild('qtyTablesChart') private qtyTablesChart: ChartComponent;
  @ViewChild('salesProductChart') private salesProductChart: ChartComponent;
  @ViewChild('ordersChart') private ordersChart: ChartComponent;
  @ViewChild('timeOrdersChart') private timeOrdersChart: ChartComponent;

  public gridData: GridDataResult;
  public statisticTurnoverData: any;

  public eventStartDate: Date;
  public eventEndDate: Date;
  public allPriceLists: any[];
  public selectedPriceList: any;
  public allDevices: DeviceUser[] = [];
  public allDeviceTypes: DeviceUserType[] = [];
  public selectedDevices: DeviceUser[] = [];
  public selectedDevicesEmpty = true;
  public selectedDeviceType: DeviceUserType;
  private allTablesArray = [];
  public allTables = [];
  public selectedTables: any[] = [];
  public selectedTablesEmpty = true;
  public hasWaiters = false;
  public missingDataWarning = false;

  public hasFiscalPrinter: boolean;

  public selectionDateRange = {
    start: null,
    end: null
  };

  public selectionTimeRange = {
    start: null,
    end: null
  };

  public chartTimeRange = {
    start: null,
    end: null
  };

  public showChartChecked = true;
  public showStatistic = false;
  public showDeleteDataChecked = false;
  public dialogOpened = false;

  public allOrders = [];
  public cancelledOrders = 0;

  public maxTurnover = 0;
  public maxOrders = 0;

  public pagingSettings = {
    pagerTypes: ['numeric', 'input'],
    type: 'input',
    // buttonCount: 5,
    info: true,
    previousNext: true,
    position: 'bottom',
    pageSize: 20,
    pageSizes: [
      10,
      20,
      50,
      100,
    ]
  };

  public sortingSettings: MultipleSortSettings = {
    allowUnsort: true,
  };

  public state: State = {
    skip: 0,
    take: 20,
  };

  public chartData: any = {};

  public expandedDetailKeys: number[] = [];

  public turnoverDataRounded = [];
  public turnoverDataIsFirstDay = true;
  public turnoverDataIsLastDay = false;
  public turnoverDataMaxValue: number;
  public timeTurnoverCategories = [];
  public dayTurnoverCategories = [];

  public ordersData = [];
  public ordersDataRounded = [];
  public maxOrdersCount = 1;
  public ordersDataIsFirstDay = true;
  public ordersDataIsLastDay = false;
  public ordersDataMaxValue: number;
  public ordersDataTotal = 0;
  public timeOrdersCategories = [];
  public dayOrdersCategories = [];

  public timeOrdersData: any[];



  public tableStats = [];
  public tableNumbersStats = [];
  public tableStatsPage = 1;
  public tableStatsItemsPerPage = 10;
  public tableStatsMaxPages: number;
  public tableStatsIsFirstPage = true;
  public tableStatsIsLastPage = false;
  public tableStatsMaxValue: number;

  public ordersTable = [];
  public tableNumbersOrders = [];
  public ordersTablePage = 1;
  public ordersTableItemsPerPage = 10;
  public ordersTableMaxPages: number;
  public ordersTableIsFirstPage = true;
  public ordersTableIsLastPage = false;
  public ordersTableMaxValue: number;

  public eventCurrency = "€";

  public eventTotalTurnover = 0;
  public eventFreeTurnover = 0;
  public eventDeletedTurnover = 0;

  public categoryTurnover;

  public calculatedEndDate;

  public highCategoryCount = false;
  public highCategoryFreeCount = false;
  public highCategoryCancelledCount = false;
  public highDeviceCount = false;
  public salesCategoriesSortedArr = [];
  public salesCategoriesFreeSortedArr = [];
  public salesCategoriesCancelledSortedArr = [];
  public salesAmountDeviceSortedArr = [];
  public salesDeviceSortedArr = [];

  private _clientId: number;

  public expandDetailsBy = (dataItem: any) => dataItem.id;

  public exportProductsData: {product: string, productInfo?: string, categoryName?: string, productPrice: number, amountPaid: number, quantityPaid?: number, amountFree?: number, quantityFree?: number, amountCancelled?: number, quantityCancelled?: number}[] = [];
  public exportWaitersData: {waiter: string, product: string, productInfo?: string, productPrice: number, amountPaid: number, quantityPaid?: number, amountFree?: number, quantityFree?: number, amountCancelled?: number, quantityCancelled?: number}[] = [];

  ngOnInit(): void {
    const accessToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
    const tokenData = this.jwtHelper.decodeToken(accessToken).data;
    this._clientId = tokenData.id;
    (<CldrIntlService>this.intlService).localeId = this._translate.currentLang;
    const endDate = new Date(this.event.endDate);
    this.calculatedEndDate = moment(endDate.setDate(endDate.getDate() + 1)).format('YYYY-MM-DD');

    this.hasFiscalPrinter = this.event.requestedSoftwareTypes.find(rs => rs.softwareType.id === 5);

    const [startYear, startMonth, startDay] = this.event.startDate.split('-').map(Number);
    const [endYear, endMonth, endDay] = this.event.endDate.split('-').map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);
    const calculatedEnd = new Date(end);
    this.eventStartDate = start;
    this.eventEndDate = calculatedEnd;
    calculatedEnd.setDate(end.getDate() + 1);

    this.selectionDateRange.start = start;
    this.selectionDateRange.end = calculatedEnd;
    this.selectionTimeRange.start = new Date(this.event.startDate);
    this.selectionTimeRange.end = new Date(this.calculatedEndDate);
    this.selectionTimeRange.start.setHours(0, 1);
    this.selectionTimeRange.end.setHours(3, 59);
    this.chartTimeRange.start = new Date(this.event.startDate);
    this.chartTimeRange.start.setHours(0, 1);
    this.chartTimeRange.end = new Date(this.calculatedEndDate);
    this.chartTimeRange.end.setHours(3, 59);
    this.hasWaiters = this.event.deviceUsers.filter(d => d.deviceUserType.id === 1).length > 0;
    this.eventCurrency = this.event.deviceUsers[0].currency;
    this._setGridData();
  }

  public onCellClick(event: CellClickEvent): void {
    const findKeyState = this.expandedDetailKeys.findIndex((i) => i === event.dataItem.id);
    if (findKeyState === -1) {
      this.expandedDetailKeys.push(event.dataItem.id);
    } else {
      this.expandedDetailKeys.splice(findKeyState, 1);
    }
    this.expandedDetailKeys = [...this.expandedDetailKeys];
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;

    this.gridData = process(this.allOrders, this.state);
    this.setPaymentStatusTexts();
  }

  private _initPriceLists() {
    this.allPriceLists = this.event.priceLists;
    if (this.allPriceLists.length > 0) {
      if (this.allPriceLists.findIndex(pl => pl.id === -2) === -1) {
        const pushedItems = {};
        pushedItems['id'] = -2;
        pushedItems['name'] = this._translate.instant('event.statistic.all');
        pushedItems['createdAt'] = null;
        this.allPriceLists.unshift(pushedItems);
      }
      if (this.selectedPriceList?.id > 0) {
        this.selectedPriceList = this.allPriceLists.find(pl => pl.id === this.selectedPriceList.id);
      } else {
        this.selectedPriceList = this.allPriceLists[0];
      }
    }
  }

  private _initDeviceTypes() {
    this.allDeviceTypes = [];
      this.event.deviceUsers.map(d => d.deviceUserType).forEach(dt => {
        if (this.allDeviceTypes.findIndex(ad => ad.id === dt.id) === -1) {
          const deviceUserType = new DeviceUserType();
          deviceUserType.id = dt.id;
          deviceUserType.name = dt.name;
          this.allDeviceTypes.push(deviceUserType);
        }
    });/*
    this.statisticTurnoverData.orders.map(o => o.turnOver.device.deviceUserType).forEach(dt => {
      if (this.allDeviceTypes.findIndex(ad => ad.id === dt.id) === -1) {
        this.allDeviceTypes.push(dt);
      }
    });*/
    if (this.allDeviceTypes.length > 0) {
      const pushedItems = new DeviceUserType();
      pushedItems.id = -2;
      pushedItems.name = this._translate.instant('event.statistic.all');
      this.allDeviceTypes.unshift(pushedItems);
      if (this.selectedDeviceType?.id > 0) {
        this.selectedDeviceType = this.allDeviceTypes.find(dt => dt.id === this.selectedDeviceType.id);
        this.allDevices = this.allDevices.filter(d => d.deviceUserType.id === this.selectedDeviceType.id || d.deviceUserType.id === -2);
      } else {
        this.selectedDeviceType = this.allDeviceTypes[0];
      }
    }
  }

  private _initDevices() {
    this.allDevices = this.event.deviceUsers.map(d => {
      const device = new DeviceUser();
      device.id = d.id;
      device.name = d.name;
      const deviceUserType = new DeviceUserType();
      deviceUserType.id = d.deviceUserType.id;
      deviceUserType.name = d.deviceUserType.name;
      device.deviceUserType = deviceUserType;
      return device;
    });
    /*this.statisticTurnoverData.orders.map(o => o.turnOver.device).forEach(d => {
      if (this.allDevices.findIndex(ad => ad.id === d.id) === -1) {
        this.allDevices.push(d);
      }
    });*/
    if (this.allDevices.length > 0) {
      const pushedItems = new DeviceUser();
      pushedItems.id = -2;
      pushedItems.name = this._translate.instant('event.statistic.all');
      pushedItems.deviceUserType = new DeviceUserType();
      pushedItems.deviceUserType.id = -2;
      pushedItems.deviceUserType.name = this._translate.instant('event.statistic.all');
    }
  }

  public _initTablesArray(turnOvers: any[]) {
    const tables = new Map();
    turnOvers.forEach(t => {
      t.order.forEach(o => {
        if (!tables.has(o.table)) {
          tables.set(o.table, {
            id: o.table,
            name: o.table,
            devices: [t.deviceUserId]
          });
        } else {
          const existingTable = tables.get(o.table);
          const devices = existingTable.devices;
          if (!devices.find(dId => dId === t.deviceUserId)) {
            devices.push(t.deviceUserId);
          }
        }
      });
    });
    this.allTablesArray.push(...Array.from(tables, ([_, v]) => (v)));
  }

  public _initTables() {
    if (this.selectedDevices.length <= 0) {
      this.allTables = this.allTablesArray;
    } else {
      this.allTables = [];
      this.selectedDevices.forEach(s => this.allTablesArray.filter(t => t.devices.findIndex(d => d === s.id) !== -1).forEach(a => this.allTables.push(a)));
      if (this.allTables.length === 1) {
        this.allTables.shift();
      }
    }
    if (this.selectedTablesEmpty) {
      this.selectedTables = this.allTables;
    }
  }

  private _setGridData() {
    this.showStatistic = false;
    const start = new Date(this.selectionDateRange.start);
    start.setHours(this.selectionTimeRange.start.getHours(), this.selectionTimeRange.start.getMinutes());
    const end = new Date(this.selectionDateRange.end);
    end.setHours(this.selectionTimeRange.end.getHours(), this.selectionTimeRange.end.getMinutes());

    this._initPriceLists();

    this._statisticsKendoService.getTurnoverData(
      this.event.id,
      this._clientId,
      this.selectedPriceList.id > 0 ? this.selectedPriceList.id : null,
      moment(start).format('YYYY-MM-DD HH:mm'),
      moment(end).format('YYYY-MM-DD HH:mm'),
      this.selectedDevices.length > 0 ? this.selectedDevices.map(s => s.id) : null,
      this.selectedDeviceType?.id > 0 ? this.selectedDeviceType.id : null,
      this.selectedTables.length > 0 ? this.selectedTables.map(s => s.id) : null,
    ).subscribe({
      next: (result) => {
        this.statisticTurnoverData = result;
        this.highCategoryCount = false;
        this.highCategoryFreeCount = false;
        this.highCategoryCancelledCount = false;
        this.highDeviceCount = false;
        this.salesCategoriesSortedArr = [];
        this.salesCategoriesFreeSortedArr = [];
        this.salesCategoriesCancelledSortedArr = [];
        this.salesAmountDeviceSortedArr = [];
        this.salesDeviceSortedArr = [];
        if (this.statisticTurnoverData.sales.categories.length > 8) {
          this.highCategoryCount = true;
          this.salesCategoriesSortedArr = this.statisticTurnoverData.sales.categories.sort((a, b) => b.amount - a.amount);
        }
        if (this.statisticTurnoverData.sales.categoriesFree.length > 8) {
          this.highCategoryFreeCount = true;
          this.salesCategoriesFreeSortedArr = this.statisticTurnoverData.sales.categoriesFree.sort((a, b) => b.amount - a.amount);
        }
        if (this.statisticTurnoverData.sales.categoriesCancelled.length > 8) {
          this.highCategoryCancelledCount = true;
          this.salesCategoriesCancelledSortedArr = this.statisticTurnoverData.sales.categoriesCancelled.sort((a, b) => b.amount - a.amount);
        }
        if (this.statisticTurnoverData.sales.devices.length > 8) {
          this.highDeviceCount = true;
          this.salesAmountDeviceSortedArr = this.statisticTurnoverData.sales.devices.sort((a, b) => b.amount - a.amount);
          this.salesDeviceSortedArr = this.statisticTurnoverData.sales.devices.sort((a, b) => b.quantity - a.quantity);
        }
        this._initDevices();
        this._initDeviceTypes();
        if (this.allTablesArray.length === 0) {
          this._initTablesArray(this.statisticTurnoverData.turnOvers);
        }
        this._initTables();
        this._initTurnoverStats();
        this._initOrdersStats();
        this._initTableStats();
        this._initTableOrders();
        this._initExportData();

        this.excelExportData = this.excelExportData.bind(this);

        this.chartData = {
          categories: {
            names: result.sales.categories.map(c => c.name),
            amounts: result.sales.categories.map(c => c.amount),
          },
          products: {
            names: result.sales.products.map(p => p.name),
            amounts: result.sales.products.map(p => p.amount),
          }
        };

        this.allOrders = [];

        let i = 0;

        this.statisticTurnoverData.turnOvers.forEach(t => {
          t.order.forEach(o => {
            let deviceType = ""
            switch (t.deviceUserTypeName) {
              case "Waiter":
                deviceType = this._translate.instant('event.statistic.waiter');
                break;
              case "Cash Register":
                deviceType = this._translate.instant('event.statistic.cashRegister');
                break;
              case "Main Device":
                deviceType = this._translate.instant('event.statistic.mainDevice');
                break;
            }
            this.allOrders.push({id: i, deviceUserName: t.nDeviceUser.name, deviceType: deviceType, order: o});
            i++;
          });
        });

        this.cancelledOrders = this.allOrders.filter(o => o.order.paymentStatus === 4).length;

        this.gridData = process(this.allOrders, this.state);

        this.setPaymentStatusTexts();

        // this.excelExportData = this.excelExportData.bind(this);

        this.showStatistic = this.allOrders?.length > 0;
      },
      error: () => console.log('Error on table rendering')
    });
  }

  public setPaymentStatusTexts() {

    this.gridData.data.forEach(d => {
      switch (d.paymentStatus) {
        // None
        case 0:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentPaid');
          break;
        // Paid
        case 1:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentPaid');
          break;
        // Free
        case 2:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentFree');
          break;
        // Viva Wallet
        case 3:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentPaid');
          break;
        // Cancelled
        case 4:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentCancelled');
          break;
        // SumUp
        case 5:
          d.paymentStatusText = this._translate.instant('event.statistic.paymentPaid');
          break;
      }
    });
  }

  public amountContent(e: any): string {
    const formattedAmount = this.intlService.formatNumber(e.dataItem.amount, 'n2');
    return `${e.dataItem.name}\n ${formattedAmount} ${this.eventCurrency}`;
  }

  public quantityContent(e: any): string {
    return `${e.dataItem.name}\n ${e.dataItem.quantity}`;
  }

  public dateContent(e: any): string {
    return moment(new Date(e.text)).format('DD-MM-YYYY');
  }

  public quantityAmountContent(e: any): string {
    const formattedAmount = this.intlService.formatNumber(e.dataItem.amount, 'n2');
    return `${e.dataItem.name}\\n${this._translate.instant('event.statistic.salesLabel')}: ${formattedAmount} ${this.eventCurrency}\\n${this._translate.instant('event.statistic.ordersLabel')}: ${e.dataItem.quantity}`;
  }

  private _initTimeCategoriesTurnover() {
    this.timeTurnoverCategories = [];
    this.dayTurnoverCategories = [];
    this.turnoverDataRounded = [];

    let day = new Date(this.selectionDateRange.start);
    if (day.getUTCHours() === 23) {
      day.setUTCHours(day.getUTCHours() + 1);
    }

    const maxDays = Math.floor((Date.UTC(this.selectionDateRange.end.getFullYear(), this.selectionDateRange.end.getMonth(), this.selectionDateRange.end.getDate()) - Date.UTC(this.selectionDateRange.start.getFullYear(), this.selectionDateRange.start.getMonth(), this.selectionDateRange.start.getDate()) ) /(1000 * 60 * 60 * 24));

    for (let currentDay = 0; currentDay <= maxDays; currentDay++) {
      for (let hour = currentDay === 0 ? this.selectionTimeRange.start.getHours() : 0; hour <= (currentDay === maxDays ? this.selectionTimeRange.end.getHours() : 23); hour++) {
        this.timeTurnoverCategories.push(moment({ hour }).format('HH:mm'));
        this.dayTurnoverCategories.push(new Date(day));
        this.turnoverDataRounded.push(0);

        this.timeTurnoverCategories.push(
          moment({
            hour,
            minute: 30
          }).format('HH:mm')
        );
        this.dayTurnoverCategories.push(new Date(day));
        this.turnoverDataRounded.push(0);
      }
      day.setUTCDate(day.getUTCDate() + 1);
    }
  }

  private _initTimeCategoriesOrders() {
    this.timeOrdersCategories = [];
    this.dayOrdersCategories = [];
    this.ordersDataRounded = [];

    let day = new Date(this.selectionDateRange.start);
    if (day.getUTCHours() === 23) {
      day.setUTCHours(day.getUTCHours() + 1);
    }
    const maxDays = Math.floor((Date.UTC(this.selectionDateRange.end.getFullYear(), this.selectionDateRange.end.getMonth(), this.selectionDateRange.end.getDate()) - Date.UTC(this.selectionDateRange.start.getFullYear(), this.selectionDateRange.start.getMonth(), this.selectionDateRange.start.getDate()) ) /(1000 * 60 * 60 * 24));

    for (let currentDay = 0; currentDay <= maxDays; currentDay++) {
      for (let hour = currentDay === 0 ? this.selectionTimeRange.start.getHours() : 0; hour <= (currentDay === maxDays ? this.selectionTimeRange.end.getHours() : 23); hour++) {
        this.timeOrdersCategories.push(moment({ hour }).format('HH:mm'));
        this.dayOrdersCategories.push(new Date(day));
        this.ordersDataRounded.push(0);

        this.timeOrdersCategories.push(
          moment({
            hour,
            minute: 30
          }).format('HH:mm')
        );
        this.dayOrdersCategories.push(new Date(day));
        this.ordersDataRounded.push(0);
      }
      day.setUTCDate(day.getUTCDate() + 1);
    }
  }

  private _initTurnoverStats() {

    this._initTimeCategoriesTurnover();

    this.eventTotalTurnover = this.statisticTurnoverData.sales.orders;
    this.eventFreeTurnover = 0;
    this.eventDeletedTurnover = 0;

    this.statisticTurnoverData.turnOvers.forEach(t => {
      t.order.forEach(order => {

        switch (order.paymentStatus) {
          case 4:
              this.eventDeletedTurnover += order.amount;
              this.eventTotalTurnover -= order.amount;
            break;
          default:
            order.orderCategory.forEach(c => {
              c.orderProduct.forEach(p => {
                if (p.freePaid >= 1) {
                  this.eventFreeTurnover += p.price * p.freePaid;
                  this.eventTotalTurnover -= p.price * p.freePaid;
                } else {
                  const dateformat = moment(order.createdAt).format('YYYY-MM-DDTHH:mm:00.000') + 'Z';

                  const day = new Date(dateformat).getUTCDate();

                  let hours = new Date(dateformat).getUTCHours();

                  const minutes = new Date(dateformat).getUTCMinutes();
                  let roundedMinutes = '';

                  if (minutes < 15) {
                    roundedMinutes = '00';
                  } else if (minutes < 45) {
                    roundedMinutes = '30';
                  } else {
                    roundedMinutes = '00';
                    if (hours < 24) {
                      hours += 1;
                    } else {
                      hours = 0;
                    }
                  }

                  let time = '';

                  if (hours < 10) {
                    time = '0' + hours + ':' + roundedMinutes;
                  } else {
                    time = hours + ':' + roundedMinutes;
                  }

                  if (hours >= 24) {
                    time = '23:30';
                  }

                  for (let i = 0; i < this.timeTurnoverCategories.length; i++) {
                    if (this.timeTurnoverCategories[i] === time && this.dayTurnoverCategories[i].getDate() === day) {
                      this.turnoverDataRounded[i] += p.price * (p.quantity - p.freePaid);
                      p.orderOption.forEach(op => {
                        this.turnoverDataRounded[i] += op.price * (op.quantity - op.freePaid);
                      });
                    }
                  }

                }
              })
            });
            break;
        }

      });
      this.eventTotalTurnover = Math.round(this.eventTotalTurnover * 100) / 100;
      this.eventFreeTurnover = Math.round(this.eventFreeTurnover * 100) / 100;
      this.eventDeletedTurnover = Math.round(this.eventDeletedTurnover * 100) / 100;
    });

    let currentDay = this.dayTurnoverCategories[0].getDate();

    for (let i = 0; i < this.timeTurnoverCategories.length; i ++) {
      if (i % 2 !== 0) {
        this.timeTurnoverCategories[i] = '';
      }

      if (i === 0 || currentDay !== this.dayTurnoverCategories[i].getDate() || this.timeTurnoverCategories[i] === '12:00') {
        currentDay = this.dayTurnoverCategories[i].getDate();
        this.timeTurnoverCategories[i] = this.timeTurnoverCategories[i] + '\n' + this.dayTurnoverCategories[i].getDate() + "/" + (this.dayTurnoverCategories[i].getMonth() === 12 ? 1 : this.dayTurnoverCategories[i].getMonth() + 1) + "/" + this.dayTurnoverCategories[i].getFullYear();
      }
    }

    this.maxTurnover = Math.max(...this.turnoverDataRounded);
  }

  private _initOrdersStats() {

    const orderMap = new Map<string, number>();

    this.statisticTurnoverData.turnOvers.forEach(t => {
      t.order.forEach(order => {
        const dateKey = moment(order.createdAt).format('YYYY-MM-DDTHH:mm:00.000') + 'Z';

        if (orderMap.has(dateKey)) {
          orderMap.set(dateKey, orderMap.get(dateKey) + 1);
        } else {
          orderMap.set(dateKey, 1);
        }
      })
    });

    this.ordersData = Array.from(orderMap.entries()).map(([dateString, count]) => ({
      date: new Date(dateString).toISOString(),
      count: count
    }));

    this._initTimeCategoriesOrders();

    this.ordersDataTotal = 0;

    this.ordersData.forEach(data => {

      this.ordersDataTotal += data.count;

      const day = new Date(data.date).getUTCDate();

      let hours = new Date(data.date).getUTCHours();

      const minutes = new Date(data.date).getUTCMinutes();
      let roundedMinutes = '';

      if (minutes < 15) {
        roundedMinutes = '00';
      } else if (minutes < 45) {
        roundedMinutes = '30';
      } else {
        roundedMinutes = '00';
        if (hours < 24) {
          hours += 1;
        } else {
          hours = 0;
        }
      }

      let time = '';

      if (hours < 10) {
        time = '0' + hours + ':' + roundedMinutes;
      } else {
        time = hours + ':' + roundedMinutes;
        }

      if (hours >= 24) {
        time = '23:30';
      }

      for (let i = 0; i < this.timeOrdersCategories.length; i++) {
        if (this.timeOrdersCategories[i] === time && this.dayOrdersCategories[i].getDate() === day) {
          this.ordersDataRounded[i] += data.count;
        }
      }
    });


    let currentDay = this.dayOrdersCategories[0].getDate();

    for (let i = 0; i < this.timeOrdersCategories.length; i ++) {
      if (i % 2 !== 0) {
        this.timeOrdersCategories[i] = '';
      }

      if (i === 0 || currentDay !== this.dayOrdersCategories[i].getDate() || this.timeOrdersCategories[i] === '12:00') {
        currentDay = this.dayOrdersCategories[i].getDate();
        this.timeOrdersCategories[i] = this.timeOrdersCategories[i] + '\n' + this.dayOrdersCategories[i].getDate() + "/" + (this.dayOrdersCategories[i].getMonth() === 12 ? 1 : this.dayOrdersCategories[i].getMonth() + 1) + "/" + this.dayOrdersCategories[i].getFullYear();
      }
    }

    this.maxOrders = Math.max(...this.ordersDataRounded);

    // this.ordersData.sort((b, a) => new Date(b.date).getTime() - new Date(a.date).getTime());

    // this.maxOrdersCount = Math.max(...this.ordersData.map(o => o.count)) + 1;
    // this.buildFilteredTimeOrdersData();
  }

  private _initTableStats() {

    this.tableStatsMaxPages = Math.ceil(this.statisticTurnoverData.sales.tables.length / this.tableStatsItemsPerPage);

    const tableArr: any = [];
    const tableNumberStatsArr: any = [];

    const sortBySalesArr = this.statisticTurnoverData.sales.tables.slice().sort((a, b) => b.amount - a.amount);

    this.tableStatsMaxValue = Math.ceil(sortBySalesArr[0].amount / 10) * 10;

    for (let i = (this.tableStatsPage - 1) * this.tableStatsItemsPerPage; i < this.tableStatsPage * this.tableStatsItemsPerPage && i < sortBySalesArr.length; i++) {
      tableArr.push([sortBySalesArr[i].amount, sortBySalesArr[i].id]);
      tableNumberStatsArr.push(sortBySalesArr[i].id);
    }

    this.tableStats = tableArr;
    this.tableNumbersStats = tableNumberStatsArr;
  }

  private _initTableOrders() {

    this.ordersTableMaxPages = Math.ceil(this.statisticTurnoverData.sales.tables.length / this.ordersTableItemsPerPage);

    const ordersArr: any = [];
    const tableNumberOrdersArr: any = [];

    const sortByOrdersArr = this.statisticTurnoverData.sales.tables.slice().sort((a, b) => b.quantity - a.quantity);

    this.ordersTableMaxValue = Math.ceil(sortByOrdersArr[0].quantity / 10) * 10;

    for (let i = (this.ordersTablePage - 1) * this.ordersTableItemsPerPage; i < this.ordersTablePage * this.ordersTableItemsPerPage && i < sortByOrdersArr.length; i++) {
      ordersArr.push([sortByOrdersArr[i].quantity, sortByOrdersArr[i].id]);
      tableNumberOrdersArr.push(sortByOrdersArr[i].id);
    }

    this.ordersTable = ordersArr;
    this.tableNumbersOrders = tableNumberOrdersArr;
  }

  public buildFilteredTimeOrdersData() {
    const [startHour, startMinute] = this.chartTimeRange.start.toISOString().split('T')[1].split(':').map(Number);
    const [endHour, endMinute] = this.chartTimeRange.end.toISOString().split('T')[1].split(':').map(Number);

    const filteredTimeOrdersData =  this.ordersData.filter(order => {
      const date = new Date(order.date);
      const hours = date.getUTCHours();
      const minutes = date.getUTCMinutes();

      // Check if the time is within the specified range
      if (startHour <= endHour) {
        // Time range does not cross midnight
        return (hours > startHour || (hours === startHour && minutes >= startMinute)) &&
          (hours < endHour || (hours === endHour && minutes < endMinute));
      } else {
        // Time range crosses midnight
        return (hours > startHour || (hours === startHour && minutes >= startMinute)) ||
          (hours < endHour || (hours === endHour && minutes < endMinute));
      }
    });

    const data = filteredTimeOrdersData.reduce((acc, order) => {
      const date = new Date(order.date);
      const day = date.toISOString().split('T')[0];
      const time = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      if (!acc[day]) {
        acc[day] = [];
      }
      acc[day].push({ count: order.count, time });
      return acc;
    }, {});

    this.timeOrdersData = Object.keys(data).map(day => ({day, orders: data[day]}));
  }

  public onSearchButtonClick() {
    if (this.showDeleteDataChecked) {
      this.dialogOpened = true;
    }

    this.resetTables();

    this._setGridData();
  }

  public resetTables() {
    this.turnoverDataIsFirstDay = true;
    this.turnoverDataIsLastDay = false;
    this.ordersDataIsFirstDay = true;
    this.ordersDataIsLastDay = false;
    this.tableStatsPage = 1;
    this.tableStatsIsFirstPage = true;
    this.tableStatsIsLastPage = false;
    this.ordersTablePage = 1;
    this.ordersTableIsFirstPage = true;
    this.ordersTableIsLastPage = false;
  }

  public onDeleteButtonClick() {
    this.dialogOpened = true;
  }

  public onResetButtonClick() {
    this.showChartChecked = true;
    this.showStatistic = false;
    this.showDeleteDataChecked = false;
    this.selectedPriceList = this.allPriceLists.find(pl => pl.id === -2);
    this.selectedDeviceType = this.allDeviceTypes.find(dt => dt.id === -2);
    this.selectedDevices = [];

    this.resetTables();

    this.ngOnInit();
  }

  public closeDialog(confirmDelete) {
    this.dialogOpened = false;
    if (confirmDelete) {
      this._statisticsKendoService.deleteTurnoverData(this.event.id, this._clientId).subscribe(result => {
        this.onResetButtonClick();
        this._setGridData();
      });
    }
  }

  public onSelectDeviceType(event: any) {
    this.selectedDeviceType = this.allDeviceTypes.find(deviceType => deviceType.id === event.id);
    this._initDevices();
    if (this.selectedDeviceType.id === -2) {
      this._initTables();
    } else {
      this.allDevices = this.allDevices.filter(d => d.deviceUserType.id === this.selectedDeviceType.id || d.deviceUserType.id === -2);
      this.selectedDevices = this.selectedDevices.filter(d => d.deviceUserType.id === this.selectedDeviceType.id);
    }
  }

  public onSelectDevice(event: any) {
    if (event.length > 0) {
      this.selectedDevices = event;
      this.selectedDevicesEmpty = false;
    } else {
      this.selectedDevices = this.allDevices;
      this.selectedDevicesEmpty = true;
    }
    this._initTables();
  }

  public onSelectTable(event: any) {
    if (event.length > 0) {
      this.selectedTables = event;
      this.selectedTablesEmpty = false;
    } else {
      this.selectedTables = this.allTables;
      this.selectedTablesEmpty = true;
    }
    this._initTables();
  }

  public onExcelExport(args: ExcelExportEvent) {
    args.preventDefault();

    const observables = [];
    const workbook = args.workbook;
    const rows = workbook.sheets[0].rows;

    const headerOptions = rows[0].cells[0];
    const data = this.gridData.data;

    for (let idx = 0; idx < data.length; idx++) {
      observables.push(data[idx]);
    }

    // zip.apply(Observable, observables).subscribe((result: GridDataResult[]) => {
      for (let idx = observables.length - 1; idx >= 0; idx--) {
        const orders = (<GridDataResult>observables[idx]).data;

        for (let orderIdx = orders.length - 1; orderIdx >= 0; orderIdx--) {
          const order = orders[orderIdx];
          rows.splice(idx + 2, 0, {
            cells: [
              {},
              {value: order.table},
              {value: order.createdAt},
              {value: order.turnOver.deviceUserName},
              {value: order.turnOver.deviceUserTypeName},
              {value: order.fiscalPrinted},
              {value: order.amount},
            ],
          });
        }

        rows.splice(idx + 2, 0, {
          cells: [
            {},
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.table'),
            }),
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.dateLabel'),
            }),
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.deviceUserName'),
            }),
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.deviceUserType'),
            }),
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.fiscalPrinted'),
            }),
            Object.assign({}, headerOptions, {
              value: this._translate.instant('event.statistic.totalAmount'),
            }),
          ],
        });
      }
    // });

    new Workbook(workbook).toDataURL().then((dataUrl: string) => {
      saveAs(dataUrl, 'statistic.xlsx');
    });
  }

  public onStatsPageChange(up: boolean) {
    if (up) {
      if (this.tableStatsPage < this.tableStatsMaxPages) {
        this.tableStatsPage += 1;
      }
    } else {
      if (this.tableStatsPage > 1) {
        this.tableStatsPage -= 1;
      }
    }

    if (this.tableStatsPage === this.tableStatsMaxPages) {
      this.tableStatsIsLastPage = true;
    } else {
      this.tableStatsIsLastPage = false;
    }
    if (this.tableStatsPage === 1) {
      this.tableStatsIsFirstPage = true;
    } else {
      this.tableStatsIsFirstPage = false;
    }

    this._initTableStats();
  }

  public onOrdersPageChange(up: boolean) {
    if (up) {
      if (this.ordersTablePage < this.ordersTableMaxPages) {
        this.ordersTablePage += 1;
      }
    } else {
      if (this.ordersTablePage > 1) {
        this.ordersTablePage -= 1;
      }
    }

    if (this.ordersTablePage === this.ordersTableMaxPages) {
      this.ordersTableIsLastPage = true;
    } else {
      this.ordersTableIsLastPage = false;
    }
    if (this.ordersTablePage === 1) {
      this.ordersTableIsFirstPage = true;
    } else {
      this.ordersTableIsFirstPage = false;
    }

    this._initTableOrders();
  }

  public excelExportData(): ExcelExportData {
    const excelState = this.state;
    const excelData = process(this.allOrders, {
      group: this.state.group,
      sort: this.state.sort,
      filter: this.state.filter
    });
    const result: ExcelExportData = {
      data: excelData.data,
      group: excelState.group
    };
    return result;
  }

  public _initExportData() {
    this.exportProductsData = [];
    this.exportWaitersData = [];
    this.statisticTurnoverData.sales.products.forEach(p => {
      this.exportProductsData.push({
        product: p.name,
        productInfo: p.info,
        categoryName: p.categoryName,
        productPrice: p.price,
        amountPaid: p.amount,
        quantityPaid: p.quantity,
        amountFree: p.amountFree,
        quantityFree: p.quantityFree,
        amountCancelled: p.amountCancelled,
        quantityCancelled: p.quantityCancelled
      });
    });

    this.statisticTurnoverData.sales.options.forEach(o => {
      this.exportProductsData.push({
        product: o.name,
        productInfo: o.info,
        categoryName: o.categoryName,
        productPrice: o.price,
        amountPaid: o.amount,
        quantityPaid: o.quantity,
        amountFree: o.amountFree,
        quantityFree: o.quantityFree,
        amountCancelled: o.amountCancelled,
        quantityCancelled: o.quantityCancelled
      });
    });

    const waitersMap = new Map();

      this.statisticTurnoverData.turnOvers.forEach(t => {
        t.order.forEach(o => {
          o.orderCategory.forEach(oc => {
            oc.orderProduct.forEach(op => {
              const existingProduct = waitersMap.get(op.id + "/" + t.deviceUserId);

              if (op.paymentStatus === 4) {
                if (existingProduct) {
                  existingProduct.amountCancelled += op.price * op.quantity;
                  existingProduct.quantityCancelled += op.quantity;
                } else {
                  waitersMap.set(op.id + "/" + t.deviceUserId, {
                    waiter: t.nDeviceUser.name,
                    product: op.name,
                    productInfo: op.extraInfo,
                    categoryName: oc.name,
                    productPrice: op.price,
                    amountPaid: 0,
                    quantityPaid: 0,
                    amountFree: 0,
                    quantityFree: 0,
                    amountCancelled: op.price * op.quantity,
                    quantityCancelled: op.quantity
                  });
                }

              } else {

                if (existingProduct) {
                  existingProduct.amountPaid += op.price * (op.quantity - op.freePaid);
                  existingProduct.quantityPaid += op.quantity - op.freePaid;
                  existingProduct.amountFree += op.price * op.freePaid;
                  existingProduct.quantityFree += op.freePaid;
                } else {
                  waitersMap.set(op.id + "/" + t.deviceUserId, {
                    waiter: t.nDeviceUser.name,
                    product: op.name,
                    productInfo: op.extraInfo,
                    categoryName: oc.name,
                    productPrice: op.price,
                    amountPaid: op.price * (op.quantity - op.freePaid),
                    quantityPaid: op.quantity - op.freePaid,
                    amountFree: op.price * op.freePaid,
                    quantityFree: op.freePaid,
                    amountCancelled: 0,
                    quantityCancelled: 0
                  });
                }
              }

              op.orderOption.forEach(oo => {
                const existingProduct = waitersMap.get(oo.name + "/" + t.deviceUserId);

                if (oo.paymentStatus === 4) {
                  if (existingProduct) {
                    existingProduct.amountCancelled += oo.price * oo.quantity;
                    existingProduct.quantityCancelled += oo.quantity;
                  } else {
                    waitersMap.set(oo.id + "/" + t.deviceUserId, {
                      waiter: t.nDeviceUser.name,
                      product: oo.name,
                      productInfo: oo.extraInfo,
                      categoryName: oc.name,
                      productPrice: oo.price,
                      amountPaid: 0,
                      quantityPaid: 0,
                      amountFree: 0,
                      quantityFree: 0,
                      amountCancelled: oo.price * oo.quantity,
                      quantityCancelled: oo.quantity
                    });
                  }

                } else {

                  if (existingProduct) {
                    existingProduct.amountPaid += oo.price * (oo.quantity - oo.freePaid);
                    existingProduct.quantityPaid += oo.quantity - oo.freePaid;
                    existingProduct.amountFree += oo.price * oo.freePaid;
                    existingProduct.quantityFree += oo.freePaid;
                  } else {
                    waitersMap.set(oo.id + "/" + t.deviceUserId, {
                      waiter: t.nDeviceUser.name,
                      product: oo.name,
                      productInfo: oo.extraInfo,
                      categoryName: oc.name,
                      productPrice: oo.price,
                      amountPaid: oo.price * (oo.quantity - oo.freePaid),
                      quantityPaid: oo.quantity - oo.freePaid,
                      amountFree: oo.price * oo.freePaid,
                      quantityFree: oo.freePaid,
                      amountCancelled: 0,
                      quantityCancelled: 0
                    });
                  }
                }
              });

            });
          });
        });
      });

      this.exportWaitersData = Array.from(waitersMap.values());

  }

  public save(
    component1: ExcelExportComponent,
    component2: ExcelExportComponent,
    component3: ExcelExportComponent
  ): void {
    Promise.all([
      component1.workbookOptions(),
      component2.workbookOptions(),
      component3.workbookOptions(),
    ]).then((workbooks) => {
      workbooks[0].sheets = workbooks[0].sheets.concat(workbooks[1].sheets, workbooks[2].sheets);
      workbooks[0].sheets[0].name = this._translate.instant('event.statistic.productsSheet');
      workbooks[0].sheets[1].name = this._translate.instant('event.statistic.waitersSheet');
      workbooks[0].sheets[2].name = this._translate.instant('event.statistic.tablesSheet');

      const infoHeaderRow = {
        type: 'header',
        cells: [
          {
            value: "Export " + this._translate.instant('offers.request.from') + ":",
          },
          {
            value: `${moment(this.selectionDateRange.start).format('DD.MM.YYYY')} ${moment(this.selectionTimeRange.start).format('HH:mm')}`,
          },
          {
            value: this._translate.instant('offers.request.to') + ":",
          },
          {
            value: `${moment(this.selectionDateRange.end).format('DD.MM.YYYY')} ${moment(this.selectionTimeRange.end).format('HH:mm')}`,
          },
        ]
      }

      workbooks[0].sheets[0].rows.unshift(infoHeaderRow);
      workbooks[0].sheets[1].rows.unshift(infoHeaderRow);
      workbooks[0].sheets[2].rows.unshift(infoHeaderRow);
      component1.save(workbooks[0]);
    });
  }

  public getSortedCategoryAmounts(): any[] {
    const dataCopy = [...this.statisticTurnoverData.sales.categories];
    return dataCopy.sort((a, b) => b.amount - a.amount);
  }

  public getFilteredSalesAmounts() {
    return this.statisticTurnoverData.sales.devices.filter(d => d.amount > 0);
  }

}
